/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { cityHead } from "../../../../../config/constant";
import { Image, Space } from "antd";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, Box, TableRow, TableCell } from "@mui/material";
import clsx from "clsx";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { NavLink } from "react-router-dom"
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const CityTable = (props) => {

    const { countryDetails, stateDetails, cityDetails, onRequestSort, customObject,
        sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement, moduleType } = props

    const [visible, setVisible] = useState(false);
    const [name, setName] = useState('');
    const [cityId, setCityId] = useState('');
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);

    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);

    const [errorCityName, setErrorCityName] = useState(false);
    const [errorStateId, setErrorStateId] = useState(false);
    const [errorCountryId, setErrorCountryId] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const dispatch = useDispatch();

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const onEdit = (data) => {
        setVisible(true);
        setCityId(data.id);
        setName(data.name);
        setStateId(data.stateId);
        setCountryId(data.countryId);
    }

    const emptyState = () => {
        setErrorCityName(false);
        setErrorStateId(false);
        setErrorCountryId(false);
    }

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const editCity = (e) => {
        e.preventDefault();
        let emptyCityName = emptyValidation('City Name', name);
        let emptyStateId = emptyValidation('State', stateId, 'dropDown');
        //let emptyCountryId = emptyValidation('Country', countryId);
        emptyState();
        if (emptyCityName.isValid && emptyStateId.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                id: cityId,
                url: 'city',
                title: "City",
                details: {
                    name: name,
                    stateId: stateId,
                    countryId: countryId,
                }
            });
        } else {
            if (emptyCityName.errors !== '') {
                setErrorCityName(emptyCityName.errors);
            } if (emptyStateId.errors !== '') {
                setErrorStateId(emptyStateId.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorCityName(error);
        }
    }, [editDetails, editError]);

    const onDelete = (data) => {
        setDeleteModal(true);
        setCityId(data.id);
        setName(data.name);
    }


    const classes = customStyles();

    const changeState = (value) => {
        setStateId(value);
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
        }
    }

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={cityHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || cityDetails === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        cityDetails && Array.isArray(cityDetails) && cityDetails?.length > 0 ? cityDetails?.map((data, i) => (

                                            <TableRow
                                                key={`${data.name}${i}`}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell style={{ width: getColumnWidth(cityHead, 0) }}><span style={{ width: getColumnWidth(cityHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(cityHead, 1) }}><span style={{ width: getColumnWidth(cityHead, 1) }}>{data.state ? data.state.name : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(cityHead, 2) }}><span style={{ width: getColumnWidth(cityHead, 2) }}>{data.country ? data.country.name : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('City', 'edit', 'Younote Admin') || checkCRUDPermission('City', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('City', 'deletable', 'Younote Admin') || checkCRUDPermission('City', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating City'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            < PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit City'}
                width={"370px"}
                className={classes.closeBackGround}
                component={
                    < Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editCity(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["City Name ", <span key={"City Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorCityName ? true : false}
                                helperText={errorCityName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <AutoCompleteComponent
                                name={["State ", <span key={"State"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                details={stateDetails}
                                parentValue={customObject(stateDetails, stateId)}
                                onChange={(data) => changeState(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                                parentError={errorStateId}
                            />
                            <AutoCompleteComponent
                                name={["Country"]}
                                heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                details={countryDetails}
                                parentValue={customObject(countryDetails, countryId)}
                                onChange={(data) => setCountryId(data.id)}
                                position={'bottom'}
                                parentError={errorCountryId}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>
                                Update & Save
                            </Button>
                        </div>
                    </Box >
                }
            />
            < DeleteModal onClose={(v) => handleDeleteModal(v)} id={cityId} loadTasks={() => loadTasks()} name={name} url={'city'} title={'City'} visible={deleteModal} />
        </>
    );
}
